
const CmgTypeform = () => <iframe src="https://haikuhealth.typeform.com/to/D50R6KUx" style={{ width: '100%', height: '70vh' }} frameBorder="0"></iframe>

export default CmgTypeform
